import { forwardRef } from "react";
import "./Checkbox.scss";

function CheckboxRender(props, ref)
{
    return <input  {...props} styleName="checkbox" type="checkbox" ref={ref} />
}

export const Checkbox = forwardRef(CheckboxRender);